import { createRoot } from 'react-dom/client';
import App from './App'
import "./index.css"

declare let module: { hot: any};

let invokeRender:() => void;
let root: any = undefined;

document.body.innerHTML = '<div class="h-svh" id="app"></div>';

const renderIn = document.getElementById('app');

if (renderIn) {
    root = createRoot(renderIn);

    invokeRender = () => {
        root.render(
            <App/>
        )        
    }
    invokeRender();

    if (module.hot) {
        console.log(`Hot reload: `, module.hot)
        module.hot.accept("./App", () => {
            console.log(`Received hot update for ./App`);

        });
        module.hot.accept((err: any, { mid, mod }: any) => {
            console.log(`Error while accepting hot module: ${err}`);
        });

        const NewApp = require("./App").default
        invokeRender = () => {
            root.render(<NewApp/>)
        }
        invokeRender();
    }
}

